// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.findUserInfo {
    padding: 64px 0;
}

.tabBtns {
    display: flex;
    margin: 0 auto;
    width: 492px;
    align-items: center;
    justify-content: flex-start;
}

.tabBtns a {
    font-size: 16px;
    padding: 6px 50px;
    text-decoration: none;
    border-radius: 0;
}

.find-wrapper {
    padding: 20px;
    margin: 0 auto;
    width: 450px;
    border: 1px solid #323232;
    text-align: left;
}

.message {
    font-weight: bold;
    color: #347DE6;
}

#tab2 {
    display: none;
}

.find-input {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 15px;
}

.find-input label {
    font-size: 14px;
    width: 80px;
}

.find-input span {
    margin: 0 3px;
}

.find-input input {
    width: 105px;
    height: 22.4px;
    padding: 3px 4px;
    border: 1px solid #dcdcdc;
}

.findController {
    margin: 50px auto 0 auto;
    display: flex;
    align-items: center;
    width: 60%;
    justify-content: space-between;
}

.findController button {
    width: 40%;
    padding: 6px 0;
    font-size: 15px;
}

#tab2 .find-input:first-of-type input {
    width: 150px;
}

@media screen and (max-width: 600px) {
    .tabBtns {
        width: calc(80% + 42px);
    }

    .tabBtns a {
        width: 50%;
        font-size: 14px;
        padding: 8px 5%;
    }

    .find-wrapper {
        width: 80%;
    }

    .find-wrapper p {
        font-size: 13px;
        margin-bottom: 20px;
    }

    .find-input {
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
    }

    .find-input label {
        font-size: 13px;
        width: 100%;
        margin-bottom: 4px;
    }

    .find-input label + div {
        width: 100%;
    }

    .find-input input {
        width: calc((100% - 12px) / 3 - 15px);
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/FindUserInfo.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,UAAU;QACV,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,WAAW;IACf;;IAEA;QACI,eAAe;QACf,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qCAAqC;IACzC;AACJ","sourcesContent":[".findUserInfo {\n    padding: 64px 0;\n}\n\n.tabBtns {\n    display: flex;\n    margin: 0 auto;\n    width: 492px;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.tabBtns a {\n    font-size: 16px;\n    padding: 6px 50px;\n    text-decoration: none;\n    border-radius: 0;\n}\n\n.find-wrapper {\n    padding: 20px;\n    margin: 0 auto;\n    width: 450px;\n    border: 1px solid #323232;\n    text-align: left;\n}\n\n.message {\n    font-weight: bold;\n    color: #347DE6;\n}\n\n#tab2 {\n    display: none;\n}\n\n.find-input {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-bottom: 15px;\n}\n\n.find-input label {\n    font-size: 14px;\n    width: 80px;\n}\n\n.find-input span {\n    margin: 0 3px;\n}\n\n.find-input input {\n    width: 105px;\n    height: 22.4px;\n    padding: 3px 4px;\n    border: 1px solid #dcdcdc;\n}\n\n.findController {\n    margin: 50px auto 0 auto;\n    display: flex;\n    align-items: center;\n    width: 60%;\n    justify-content: space-between;\n}\n\n.findController button {\n    width: 40%;\n    padding: 6px 0;\n    font-size: 15px;\n}\n\n#tab2 .find-input:first-of-type input {\n    width: 150px;\n}\n\n@media screen and (max-width: 600px) {\n    .tabBtns {\n        width: calc(80% + 42px);\n    }\n\n    .tabBtns a {\n        width: 50%;\n        font-size: 14px;\n        padding: 8px 5%;\n    }\n\n    .find-wrapper {\n        width: 80%;\n    }\n\n    .find-wrapper p {\n        font-size: 13px;\n        margin-bottom: 20px;\n    }\n\n    .find-input {\n        flex-direction: column;\n        align-items: flex-start;\n        width: 100%;\n    }\n\n    .find-input label {\n        font-size: 13px;\n        width: 100%;\n        margin-bottom: 4px;\n    }\n\n    .find-input label + div {\n        width: 100%;\n    }\n\n    .find-input input {\n        width: calc((100% - 12px) / 3 - 15px);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
